import { render, staticRenderFns } from "./CasConfirmation.vue?vue&type=template&id=67fff012&scoped=true&"
import script from "./CasConfirmation.vue?vue&type=script&lang=js&"
export * from "./CasConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fff012",
  null
  
)

export default component.exports